(() => {
    const el = document.createElement('div');

    if (typeof el.style.grid !== 'string') {
        document.querySelector('html').classList.add('no-cssgrid');
    }
})();
